import { render, staticRenderFns } from "./triple_arrow_button.vue?vue&type=template&id=1b05cc5a&"
import script from "./triple_arrow_button.vue?vue&type=script&lang=js&"
export * from "./triple_arrow_button.vue?vue&type=script&lang=js&"
import style0 from "./triple_arrow_button.vue?vue&type=style&index=0&id=1b05cc5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports